/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_1_TextInputs */

const en_visa_e2_extra_point_1_text = /** @type {(inputs: Visa_E2_Extra_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The business must be real and active, with evidence that supports the scale and purpose of the trade or investment.`)
};

const pt_visa_e2_extra_point_1_text = /** @type {(inputs: Visa_E2_Extra_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O negócio deve ser real e ativo, com evidência que apoie a escala e o propósito do comércio ou investimento.`)
};

const es_visa_e2_extra_point_1_text = /** @type {(inputs: Visa_E2_Extra_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El negocio debe ser real y activo, con evidencia que respalde la escala y el propósito del comercio o la inversión.`)
};

/**
* | output |
* | --- |
* | "The business must be real and active, with evidence that supports the scale and purpose of the trade or investment." |
*
* @param {Visa_E2_Extra_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_1_text = /** @type {((inputs?: Visa_E2_Extra_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_1_text(inputs)
	if (locale === "es") return es_visa_e2_extra_point_1_text(inputs)
	return en_visa_e2_extra_point_1_text(inputs)
});